import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import type React from 'react';
import styles from './index.module.scss';

export const DESIGNATED_ENROLLMENT_COURSES_SETTING_SECTION = graphql(
  /* GraphQL */ `
  fragment DesignatedEnrollmentCoursesSettingSection on DesignatedEnrollmentCoursesSetting {
    id
    name
    description
    startsOn
    endsOn
  }
`,
);

export type DesignatedEnrollmentCoursesSettingSectionProps = {
  setting: FragmentType<typeof DESIGNATED_ENROLLMENT_COURSES_SETTING_SECTION>;
  children: React.ReactNode;
};

export const DesignatedEnrollmentCoursesSettingSection: React.FC<
  DesignatedEnrollmentCoursesSettingSectionProps
> = ({ setting, children }) => {
  const settingData = useFragment(
    DESIGNATED_ENROLLMENT_COURSES_SETTING_SECTION,
    setting,
  );

  return (
    <section className={styles.section}>
      <div className={styles.tab}>
        <h2 className={styles.title}>{settingData.name}</h2>
      </div>
      <div className={styles.content}>
        <p className={styles.period}>
          <span className={styles.periodLabel}>期間</span>
          <span className={styles.periodDate}>{settingData.startsOn}</span>
          <span className={styles.periodLabel}>から</span>
          <span className={styles.periodDate}>{settingData.endsOn}</span>
          <span className={styles.periodLabel}>まで</span>
        </p>
        {settingData.description && (
          <p className={styles.description}>{settingData.description}</p>
        )}
        <ul className={styles.courseList}>{children}</ul>
      </div>
    </section>
  );
};
